import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AuthService} from '../../../services/auth/auth.service';
import {UserModel} from '../../../models/user.model';
import {Router} from '@angular/router';

declare var UIkit: any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    error = false;

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
    }

    ngOnInit() {
        this.error = false;
        if (this.authService.isLoggedIn) {
            this.router.navigateByUrl('/dashboard');
        }
    }

    onSubmit(form: NgForm) {
        this.authService.login(form.value).subscribe(
            (response: UserModel) => {
                this.error = false;
                this.authService.setUserModel(response);
                this.router.navigateByUrl('/dashboard');
            }, e => {
                this.error = true;
            }
        );
    }

}
